var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.994141 12.6299C0.994141 6.97303 0.994141 4.1446 2.7515 2.38724C4.50886 0.629883 7.33729 0.629883 12.9941 0.629883H24.9941C30.651 0.629883 33.4794 0.629883 35.2368 2.38724C36.9941 4.1446 36.9941 6.97303 36.9941 12.6299V16.0299C36.9941 16.3127 36.9941 16.4541 36.9063 16.542C36.8184 16.6299 36.677 16.6299 36.3941 16.6299H27.9941C27.0648 16.6299 26.6002 16.6299 26.2138 16.7067C24.627 17.0224 23.3866 18.2628 23.071 19.8495C22.9941 20.2359 22.9941 20.7006 22.9941 21.6299C22.9941 22.5592 22.9941 23.0238 23.071 23.4102C23.3866 24.997 24.627 26.2374 26.2138 26.553C26.6002 26.6299 27.0648 26.6299 27.9941 26.6299H36.7084C36.8662 26.6299 36.9941 26.7578 36.9941 26.9156C36.9941 30.0715 34.4358 32.6299 31.2799 32.6299H12.9941C7.33729 32.6299 4.50886 32.6299 2.7515 30.8725C0.994141 29.1152 0.994141 26.2867 0.994141 20.6299V12.6299Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9941 20.6309C22.9941 18.4217 24.785 16.6309 26.9941 16.6309H36.6941C36.8598 16.6309 36.9941 16.7652 36.9941 16.9309V26.3309C36.9941 26.4965 36.8598 26.6309 36.6941 26.6309H26.9941C24.785 26.6309 22.9941 24.84 22.9941 22.6309V20.6309Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.99414,
    y: 6.62988,
    width: 12,
    height: 2,
    rx: 1,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.be2a9c4a0555e376740414953c2f2663.svg";
export { ForwardRef as ReactComponent };